import { render } from "./CardTodo.vue?vue&type=template&id=1b6d6142&scoped=true&ts=true"
import script from "./CardTodo.vue?vue&type=script&lang=ts"
export * from "./CardTodo.vue?vue&type=script&lang=ts"

import "./CardTodo.vue?vue&type=style&index=0&id=1b6d6142&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6d6142"]])

export default __exports__